import React, { useEffect, useState } from 'react';
import { getShiftInvoiceLink } from '../Api.js';
import '../business/store/ConfirmationModal.scss';

const InvoiceErrorModal = ({ message, close }) => {
  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, []);

  return (
    <section
      className={'confirmation-modal-container'}
      role={'dialog'}
      aria-modal={'true'}
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
    >
      <section className={'confirmation-modal'}>
        <section className={'confirmation-modal-content'}>
          <h3 className={'confirmation-title'}>{'Unable to open invoice'}</h3>
          <p className={'confirmation-text'}>{message}</p>
          <section className={'buttons'}>
            <button className={'confirm very-dark'} type={'button'} onClick={close}>{'Close'}</button>
          </section>
        </section>
      </section>
    </section>
  );
};

const DEFAULT_ERROR = 'We could not load your invoice right now. Try again in a few minutes, or email hello@locum.ly.';

/**
 * Fetches a fresh Stripe invoice PDF URL, then opens it.
 * @param {{ shiftId: string, className?: string, onClick?: function, label?: string }} props
 */
const ViewInvoiceButton = ({ shiftId, className = 'download-invoice-button very-light', onClick, label = 'View Invoice' }) => {
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const openInvoice = async (e) => {
    if (onClick) {
      onClick(e);
    }
    if (e && e.stopPropagation) {
      e.stopPropagation();
    }
    if (loading || !shiftId) {
      return;
    }
    setLoading(true);
    try {
      const { invoiceLink } = await getShiftInvoiceLink(shiftId);
      if (!invoiceLink) {
        setErrorMessage(DEFAULT_ERROR);
        return;
      }
      // Open after fetch completes. Prefer window.open so we don't navigate the app away.
      const opened = window.open(invoiceLink, '_blank', 'noopener,noreferrer');
      if (!opened) {
        const link = document.createElement('a');
        link.href = invoiceLink;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        link.click();
      }
    }
    catch (err) {
      setErrorMessage((err && err.message) || DEFAULT_ERROR);
    }
    finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button
        className={`${className}${loading ? ' disabled' : ''}`}
        type={'button'}
        onClick={openInvoice}
        disabled={loading}
      >
        {loading ? 'Loading...' : label}
      </button>
      { errorMessage &&
        <InvoiceErrorModal message={errorMessage} close={() => setErrorMessage(null)} />
      }
    </>
  );
};

export default ViewInvoiceButton;
